if($('#episodes-search').length) {

    let searchContainer = $('#episodes-search'),
        resultsContainer = $('#episodes-search-results'),
        paginationContainer = $('#episodes-pagination-container'),
        paginationDisplay = $('.episodes-pagination-display'),
        initialSearchComplete = false,
        topicFilterItems = $('.episodes-filter-topic'),
        yearFilterItems = $('.episodes-filter-year'),
        currentFilterTags = $('.episodes-current-filter-tags'),
        page = 1;

    $(document).on('click', '.episodes-page-link', function (e) {
        e.preventDefault();
        page = $(this).data('page');
        episodesSearch();
    });

    $(document).on('click', '.episodes-page-prev', function (e) {
        e.preventDefault();
        if($(this).hasClass('disabled')) return;
        page--;
        episodesSearch();
    });

    $(document).on('click', '.episodes-page-next', function (e) {
        e.preventDefault();
        if($(this).hasClass('disabled')) return;
        page++;
        episodesSearch();
    });

    topicFilterItems.on('click', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('is-checked');
        if ($('.is-checked').length > 0) {
            $('.js-services-clear').removeClass('d-none');
        } else {
            $('.js-services-clear').addClass('d-none');
        }
        episodesSearch();
    });

    yearFilterItems.on('click', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('is-checked');
        if ($('.is-checked').length > 0) {
            $('.js-services-clear').removeClass('d-none');
        } else {
            $('.js-services-clear').addClass('d-none');
        }
        episodesSearch();
    });

    $(document).on('click', '.episodes-current-filter-tags button', function () {
        $('.episodes-filter-topic-' + $(this).data('topic')).parent().removeClass('is-checked');
        $('.episodes-filter-year-' + $(this).data('year')).parent().removeClass('is-checked');
        if ($('.is-checked').length > 0) {
            $('.js-services-clear').removeClass('d-none');
        } else {
            $('.js-services-clear').addClass('d-none');
        }
        episodesSearch();
    });

    $(document).on('click', '.view-all-topics', function (e) {
        e.preventDefault();

        $('.topic-hidden').toggleClass('d-none');

        if ($('.topic-hidden').hasClass('d-none')) {
            $(this).text('View All');
        } else {
            $(this).text('View Less');
        }
    });


    $(document).on('click', '.js-services-clear', function () {
        // $('.press-release-filter-category').each(function() {
        //     $('.press-release-filter-category-' + $(this).data('category')).parent().removeClass('is-checked');
        // });

        topicFilterItems.parent().removeClass('is-checked');
        yearFilterItems.parent().removeClass('is-checked');

        $('.js-services-clear').addClass('d-none');

        page = 1;

        episodesSearch();
    });



    function episodesSearch() {

        let topicFilters = [],
            yearFilters = [];

        topicFilterItems.each(function() {
            if($(this).parent().hasClass('is-checked')) {
                topicFilters.push($(this).data('topic'));
            }
        });

        yearFilterItems.each(function() {
            if($(this).parent().hasClass('is-checked')) {
                yearFilters.push($(this).data('year'));
            }
        });

        console.log('topicFilters', topicFilters);
        console.log('yearFilters', yearFilters);

        $.post("/wp-admin/admin-ajax.php", {
            'action': 'episodes_search',
            'topics': topicFilters,
            'years': yearFilters,
            'page': page,
        }, function (response) {

            resultsContainer.html(response.data.results);
            paginationContainer.html(response.data.pagination);
            paginationDisplay.html(response.data.pagination_display);
            currentFilterTags.html(response.data.current_filter_tags);

            $('html, body').animate({
                scrollTop: $('#episode-search').offset().top - 100
            }, 500);

        });

    }

}
